import { render, staticRenderFns } from "./createModal.vue?vue&type=template&id=51e23c62&scoped=true&"
import script from "./createModal.vue?vue&type=script&lang=js&"
export * from "./createModal.vue?vue&type=script&lang=js&"
import style0 from "./createModal.vue?vue&type=style&index=0&id=51e23c62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e23c62",
  null
  
)

export default component.exports